<template>
  <div class="footer">
    <b-card class="w-100">
      <b-button
        variant="link"
        class="float-left text-transform-none go-back"
        size="lg"
        @click="$emit('exit')"
        :disabled="isLoading"
        :title="labels.exit"
      >
        <i class="mdi mdi-exit-to-app"></i>
        {{ labels.exit }}
      </b-button>
      <b-button
        v-if="activeTab === 1"
        class="float-left text-transform-none go-back"
        variant="link"
        size="lg"
        @click="$emit('saveDraftAndExit')"
        :disabled="isLoading"
        :title="labels.draft"
      >
        <i class="mdi mdi-loading mdi-spin" v-if="isLoading"></i>
        <i class="mdi mdi-content-save" v-else></i>
        {{ labels.draft }}
      </b-button>
      <b-button
        v-if="activeTab < 2"
        variant="secondary"
        class="mr-2 float-right"
        @click="goForward()"
        :disabled="isLoading"
        :title="labels.next"
      >
        {{ labels.next }}
        <i class="mdi mdi-arrow-right"></i>
      </b-button>
      <b-button
        v-if="activeTab === 2"
        variant="secondary"
        class="mr-2 float-right"
        @click="$emit('sendSurvey')"
        :disabled="isLoading"
        :title="labels.send"
      >
        {{ labels.send }}
      </b-button>
      <b-button
        v-if="activeTab === 2"
        variant="blue"
        class="mr-2 float-right"
        @click="$emit('scheduleSurvey')"
        :disabled="isLoading"
        :title="labels.schedule"
      >
        {{ labels.schedule }}
      </b-button>
      <b-button
        v-if="activeTab > 0"
        variant="link"
        class="mr-2 float-right text-transform-none"
        size="lg"
        @click="goBack()"
        :disabled="isLoading"
        :title="labels.back"
      >
        <i class="mdi mdi-arrow-left"></i>
        {{ labels.back }}
      </b-button>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const props = {
  activeTab: {
    type: Number,
    default: 0,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
}

export default {
  props,
  computed: {
    ...mapGetters({
      resources: 'resources',
      isTemplate: 'customSurveys/isTemplate',
    }),
    labels() {
      return this.resources.component.customSurveys.create.layout.footer
    },
  },
  methods: {
    goBack() {
      this.$emit('changeTab', this.activeTab - (this.isTemplate ? 2 : 1))
    },
    goForward() {
      this.$emit('changeTab', this.activeTab + (this.isTemplate ? 2 : 1))
    },
  },
}
</script>

<style lang="scss" scoped>
.go-back {
  min-width: 0px !important;
  padding-left: 0px;
}

.btn {
  border-radius: 10px !important;
  min-width: 160px;
}
</style>
